<template>
  <div>
    <BaseNav
      :logo="logo"
      :navLinks="navLinks"
      :socialLinks="socialLinks"
      @toggleNav="toggleNav"
      @closeNav="closeNav"
    >
      <!-- SLOT FOR SUB NAVIGATION, USED AT DAYZ project -->
      <slot name="subNav"></slot>
    </BaseNav>

    <div class="main-overlay"><slot></slot></div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import BaseHeader from "./Header/BaseHeader";
import BaseNav from "./Header/BaseNav";

export default {
  name: "main-page-wrapper",
  props: {
    logo: {
      type: Object,
      validator(val) {
        return val.url && val.alt;
      }
    },
    headerBg: String,
    socialLinks: Array,
    navLinks: Array,
    activeRoute: [String, Object],
    user: Object
  },
  components: {
    BaseHeader,
    BaseNav
  },
  data() {
    return {
      navIsOpen: false,
      windowWidth: null
    };
  },
  computed: {
    hideNavOnResizeDebounced() {
      return debounce(this.hideNavOnResize, 500);
    }
  },
  methods: {
    toggleNav(val) {
      if (this.navIsOpen !== val) {
        this.navIsOpen = val !== undefined ? val : !this.navIsOpen;
      }
    },
    closeNav() {
      this.toggleNav(false);
    },
    hideNavOnResize() {
      const wiw = window.innerWidth;
      if (wiw !== this.windowWidth) {
        this.windowWidth = wiw;
        this.closeNav();
      }
    }
  },
  watch: {
    navIsOpen(val) {
      if (val) {
        window.addEventListener("resize", this.hideNavOnResizeDebounced, {
          passive: true
        });
        document.body.classList.add("open-header");
      } else {
        window.removeEventListener("resize", this.hideNavOnResizeDebounced);
        document.body.classList.remove("open-header");
      }
    },
    activeRoute() {
      this.closeNav();
    }
  },
  created() {
    this.windowWidth = window.innerWidth;
  }
};
</script>

<style lang="scss">
@import "../assets/styles/vars";

.main-nav-sticky-space {
  display: none;
  height: $navSize;

  @media (max-width: $screen-xl) {
    height: $navSizeSm;
  }

  @media (max-width: $screen-sm-max) {
    display: none !important;
  }
}

.main-overlay {
  position: relative;
  z-index: 1;
  overflow: hidden;
  transition: all $transitionSlide;

  &::before {
    content: "";
    visibility: hidden;
    opacity: 0;
    position: fixed;
    z-index: 0;
    background-color: rgba(0, 0, 0, 0.7);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: all $transitionSlideDuration;
  }
}

.open-header {
  pointer-events: none;
  overflow: hidden;

  .main-nav-wrap {
    transform: translate(-315px, 0);
  }

  .main-nav {
    pointer-events: auto;
    z-index: 200;
  }

  .main-nav__hamburger {
    pointer-events: auto;
  }

  .main-overlay {
    transform: translate(-315px, 0);
    pointer-events: none;

    &::before {
      opacity: 1;
      visibility: visible;
      z-index: 100;
    }
  }
}
</style>
